import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { useSiteMedia } from "@/lib/siteImages";
import Reveal from "@/components/Reveal";

export default function About() {
  const { t } = useLanguage();
  const media = useSiteMedia();
  const stats = [
    { v: "11+", l: t.about.statsY },
    { v: "6", l: t.about.statsC },
    { v: "10", l: t.about.statsP },
    { v: "GMP", l: t.about.statsS },
  ];
  const values = [
    { t: t.about.v1t, x: t.about.v1x },
    { t: t.about.v2t, x: t.about.v2x },
    { t: t.about.v3t, x: t.about.v3x },
    { t: t.about.v4t, x: t.about.v4x },
  ];
  return (
    <div data-testid="about-page" className="bg-white">
      <section className="relative overflow-hidden bg-navy pb-24 pt-28 text-white noise-bg lg:pb-32">
        <div className="spotlight absolute inset-0" />
        <span aria-hidden className="text-ghost-light pointer-events-none absolute -bottom-10 end-0 select-none font-display text-[16vw] italic leading-none">
          Athens
        </span>
        <div className="relative mx-auto max-w-7xl px-6">
          <Reveal><p className="label-luxe text-gold">{t.about.kicker}</p></Reveal>
          <Reveal delay={1}>
            <h1 className="mt-6 max-w-3xl font-display text-5xl font-light tracking-tight sm:text-6xl">{t.about.title}</h1>
          </Reveal>
          <Reveal delay={2}>
            <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-white/55">{t.about.lead}</p>
          </Reveal>
          <Reveal delay={3}>
            <Link to="/shop" data-testid="about-hero-cta" className="btn-gold-luxe mt-10 inline-block">{t.about.cta || t.nav.shop}</Link>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto grid max-w-7xl gap-16 px-6 py-24 lg:grid-cols-2 lg:py-32">
        <div className="space-y-6 text-sm font-light leading-relaxed text-navy/65">
          <Reveal><p data-testid="about-p1">{t.about.p1}</p></Reveal>
          <Reveal delay={1}><p data-testid="about-p2">{t.about.p2}</p></Reveal>
          <Reveal delay={2}><p data-testid="about-p3">{t.about.p3}</p></Reveal>
        </div>
        <Reveal delay={2}>
          <div className="img-zoom-frame border border-navy/10">
            <img src={media("about-lab")} alt="Antalia Pharma laboratory" data-testid="about-image" className="aspect-[4/3] w-full object-cover" loading="lazy" />
          </div>
        </Reveal>
      </section>

      <section className="border-y border-navy/10 bg-surface">
        <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i} className={`px-6 py-12 text-center ${i > 0 ? "border-s border-navy/10" : ""}`}>
              <p data-testid={`about-stat-${i}`} className="font-display text-4xl font-light text-navy lg:text-5xl">{s.v}</p>
              <p className="label-luxe mt-3 text-navy/40">{s.l}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-24 lg:py-32">
        <Reveal>
          <h2 className="font-display text-4xl font-light tracking-tight text-navy">{t.about.values}</h2>
        </Reveal>
        <div className="mt-12 grid gap-px bg-navy/10 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v, i) => (
            <Reveal key={i} delay={i} className="bg-white p-8">
              <p className="font-display text-2xl font-light text-gold-dark">0{i + 1}</p>
              <h3 className="mt-5 font-display text-xl font-medium text-navy">{v.t}</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-navy/50">{v.x}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
